<template>
  <span>
    <v-icon v-if="reversed" class="reversed">{{ icon }}</v-icon>
    <v-icon v-else class="regular">{{ icon }}</v-icon>
  </span>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true
    },
    reversed: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.reversed:before {
  color: white !important;
}

.regular:before {
  color: $primary !important;
}
</style>
